import { type ComponentType } from 'react';
import { type ReadReceipts, type MessageFile } from '@avanta/shared/types/chat';
import { getFileExtension } from '@avanta/shared/utils/common';
import { FileMessage } from '../MediaMessages';
import { MessageFileType } from './types';

export const isMessageReadByOther = (
  receipts: ReadReceipts | undefined,
  otherUserId: string | undefined,
  messageTimetoken: string
): boolean => {
  if (!receipts || !otherUserId) return false;
  let timetoken: bigint;
  try {
    timetoken = BigInt(messageTimetoken);
  } catch {
    return false;
  }
  return Object.entries(receipts).some(([lastReadTimetoken, userIds]) => {
    if (!userIds.includes(otherUserId)) return false;
    try {
      return BigInt(lastReadTimetoken) >= timetoken;
    } catch {
      return false;
    }
  });
};

export const getFileComponent = (type?: string): ComponentType<MessageFile> => {
  const extension = getFileExtension(type);
  return MessageFileType[extension as keyof typeof MessageFileType] || FileMessage;
};
